import React, { useEffect, useState } from 'react';
import HistoricoDocumentoDigital from '~/Components/DocumentoDigital/HistoricoDocumentoDigital';
import { TiposDocDigital, StatusDocumentoDigital } from '~/constant';
import { toast } from 'react-toastify';
import Loading from '~/Components/Loading';
import * as api from '~/Services/Service';
import { Button } from 'react-bootstrap';
import ModalCancelar from '../../Components/DocumentoDigital/ModalCancelar';
import CancelarDocDgital from '~/Pages/CancelarDocDigital/cancelarDocDigital';

const DetalheCancelamentoDocDigital = ({ codPreVenda }) => {
  const [documentoDigital, setDocumentoDigital] = useState();
  const [isLoadingData, setIsLoadingData] = useState();
  const [isPossibleToRequest, setIsPossibleToRequest] = useState(true);
  const [showModalCancelar, setShowModalCancelar] = useState();
  const [motivos, setMotivos] = useState();
  const [showCancelar, setShowCancelar] = useState(false);

  useEffect(() => {
    async function buscarDados() {
      setIsLoadingData(true);
      let codigoDoc = await api.obterCodigoDocDigital(codPreVenda);
      if (codigoDoc) {
        await loadFromCodDocumentoDigital(codigoDoc);
      } else if (codPreVenda) {
        await loadFromNumeroPreVenda(codPreVenda);
      }
      setIsLoadingData(false);
    }
    buscarDados();
  }, []);

  async function loadFromNumeroPreVenda(codPreVenda) {
    try {
      const response = await api.buscarPreviaDocDigital(
        codPreVenda,
        TiposDocDigital.ContratoVenda
      );
      setDocumentoDigital(response);
    } catch (err) {
      console.error(err);
      toast.error(
        err.message || 'Falha ao buscar o documento digital pela pré-venda'
      );
    }
  }

  async function loadFromCodDocumentoDigital(codDocumentoDigital) {
    try {
      const response = await api.buscarDocumentoDigital(codDocumentoDigital);
      setDocumentoDigital(response);
    } catch (err) {
      console.error(err);
      toast.error(err.message || 'Falha ao buscar o documento digital');
    }
  }

  const TiposNaoPossibilitaRequest = {
    implantado: 1,
    finalizado: 8,
    descartado: 4,
    cancelado: 7,
  };

  useEffect(() => {
    if (
      (documentoDigital &&
        Object.values(TiposNaoPossibilitaRequest).includes(
          documentoDigital.status
        )) ||
      (documentoDigital &&
        documentoDigital.log.length > 0 &&
        documentoDigital.log[0].evento &&
        documentoDigital.log[0].evento === 16)
    ) {
      setIsPossibleToRequest(false);
    } else {
      setIsPossibleToRequest(true);
    }

    if (
      documentoDigital &&
      documentoDigital.codigo &&
      documentoDigital &&
      documentoDigital.log.length > 0 &&
      documentoDigital.log[0].evento &&
      documentoDigital.log[0].evento === 16
    ) {
      setShowCancelar(true);
    } else {
      setShowCancelar(false);
    }
  }, [documentoDigital]);

  const solicitarCancelamentoDocDigital = async (
    values,
    { setSubmitting, resetForm }
  ) => {
    try {
      const response = await api.solicitarCancelamentoDocDigital(
        documentoDigital.codigo,
        values.observacao,
        values.motivoCancelar
      );
      toast.success('Solicitacao Feita Com Sucesso.');
      setDocumentoDigital(response);
    } catch (err) {
      toast.error(
        err.message || 'Falha Ao Solicitar O Cancelamento Do Documento Digital'
      );
    } finally {
      setShowModalCancelar(false);
    }
  };

  async function fetchMotivos(tipoContrato) {
    setIsLoadingData(true);
    try {
      const response = await api.buscarMotivosCancelamento(tipoContrato);
      setMotivos(response);
    } catch (error) {
      console.error(error);
      toast.error(error.message || 'Falha ao buscar os motivos');
    } finally {
      setIsLoadingData(false);
    }
  }

  const abrirModalCancelamento = () => {
    fetchMotivos(documentoDigital.tipo);
    setShowModalCancelar(true);
  };

  return (
    <>
      {!isLoadingData &&
        !isPossibleToRequest &&
        documentoDigital &&
        !showCancelar && (
          <span>
            Não é possível solicitar o cancelamento do documento digital
          </span>
        )}

      {showCancelar && (
        <>
          <div>
            <CancelarDocDgital
              codigoDocDigitalForceInput={documentoDigital.codigo}
            />
          </div>
        </>
      )}

      {!isLoadingData && isPossibleToRequest && (
        <>
          <ul className="list-unstyled d-flex mb-0">
            <li className="mr-2">
              <h5>
                Solicitar <span className="text-danger">Cancelamento</span> do
                Documento Digital
              </h5>
            </li>

            <li className="mr-2 ml-auto">
              <Button variant="danger" onClick={abrirModalCancelamento}>
                Solicitar
              </Button>
            </li>
          </ul>
        </>
      )}

      {showModalCancelar && documentoDigital && documentoDigital.status !== 0 && (
        <ModalCancelar
          show={showModalCancelar}
          onClosing={() => {
            setShowModalCancelar(false);
          }}
          onSubmit={solicitarCancelamentoDocDigital}
          opcao={'Solicitar Cancelamento Doc Digital'}
          isLoadingData={isLoadingData}
          motivos={motivos}
        />
      )}

      {isLoadingData && <Loading />}
      {!isLoadingData && documentoDigital && documentoDigital.status !== 0 && (
        <HistoricoDocumentoDigital documento={documentoDigital} />
      )}
    </>
  );
};

export default DetalheCancelamentoDocDigital;
